export const DOCUMENTS_PER_PAGE = 30;
export const DOCUMENTS_LIST_TEST_ID = 'documentsListTestId';
